export const workItemStates = ['New', 'Active', 'Resolved', 'Closed', 'Removed'];
export const workItemTypes = ['Epic', 'Feature', 'User Story', 'Task', 'Bug', 'Issue', 'Test Case'];